import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDeliveryNoteCreate,
  detail: routeDeliveryNoteDetail,
  home: routeDeliveryNotesHome,
  root: routeDeliveryNotesRoot,
} = createDoctypeRoutes({
  createName: 'new-delivery-note',
  createPath: 'new-delivery-note',
  detailName: 'deliveryNoteDetail',
  doctype: DOCTYPES.DELIVERY_NOTE,
  homeName: 'delivery-notes-home',
  path: 'delivery-notes',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/deliveryNotes/AddDeliveryNote.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/deliveryNotes/ViewDeliveryNote.vue'),
    list: async () => await import('@/components/viewsExternal/deliveryNotes/DeliveryNoteView.vue'),
  },
})

export {
  routeDeliveryNoteCreate,
  routeDeliveryNoteDetail,
  routeDeliveryNotesHome,
  routeDeliveryNotesRoot,
}
